import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { initRecaptchaScriptLoaderService } from './recaptcha-script-loader-init';
import { RecaptchaScriptLoaderService } from './recaptcha-script-loader.service';

@NgModule({
  imports: [CommonModule],
})
export class RecaptchaSharedUtilCoreModule {
  static forRoot(): ModuleWithProviders<RecaptchaSharedUtilCoreModule> {
    return {
      ngModule: RecaptchaSharedUtilCoreModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = initRecaptchaScriptLoaderService(
            inject(RecaptchaScriptLoaderService),
          );
          return initializerFn();
        }),
      ],
    };
  }
}
